import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './NavBar';
import HomePage from './HomePage';
import TaskBar from './TaskBar';
import Presets from './Presets';  
import Welcome from './Welcome';


export default function App(props) {
  // track selected preset and colors
  const [selectedPreset, setSelectedPreset] = useState('');
  const [selectedColors, setSelectedColors] = useState({leftBarColor: '#1e1e1e'});

  const handleSelectPreset = (presetClassName, presetColors) => {
    setSelectedPreset(presetClassName);
    setSelectedColors(presetColors);
  };

  return (
    <Router>
      <NavBar />
      <Routes>
        <Route
          path="/"
          element={
            <HomePage
              onSelectPreset={handleSelectPreset}
              selectedPreset={selectedPreset}
              selectedColors={selectedColors}
            />
          }
        />
        <Route path="/taskbar" element={<TaskBar /> } />
        <Route
          path="/presets"
          element={
            <Presets
              onSelectPreset={handleSelectPreset}
              selectedPreset={selectedPreset}
              selectedColors={selectedColors}
            />
          }
        />
        <Route path="/welcome" element={<Welcome />} />
      </Routes>
    </Router>
  );
};

